fx.ns("desktop.common.screens", class Copying extends fx.Component{
    
	constructor()
	{
		super();
		this.destroyOnSwitch = true;
	}

	create()
	{
		let box = new fx.components.Box();

		box.addChild(new shared.component.Person(fx.get("assets").splashPhoto), {width:260, height : 260, top : 0, left : "center"});


		let title = new fx.components.Text({text : fx.text("Copie en cours"), className : "title center"});
		let text = new fx.components.Text({text : fx.text("Ca va être rapide !"), className : "text center"});

		box.addChild(title, {width:"100%", height : 40, top : 280, left : "center"});
		box.addChild(text, {width:"100%", height : 20, top : 330, left : "center"});

		this.addChild(box, { width : 400, height : 350, top : "center", left : "center"});
	}

});

	